<template>
  <div>
    <div
      :id="id"
      class="fixed left-0 z-[999] w-[304px] overflow-y-auto overflow-x-hidden bg-gray-700"
      :class="{
        'h-[calc(100vh-108px)]': !isDragging && !topBarStore.showWindowBar,
        'h-[calc(100vh-140px)]': !isDragging && topBarStore.showWindowBar,
        'h-[450px] rounded-md': isDragging,
        'top-[140px]': topBarStore.showWindowBar,
        'top-[108px]': !topBarStore.showWindowBar,
      }"
    >
      <TButton class="!absolute right-4 top-4" @click="$emit('close')">
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.9609 5.48438C14.2422 5.17969 14.7344 5.17969 15.0156 5.48438C15.3203 5.76562 15.3203 6.25781 15.0156 6.53906L11.0547 10.5L15.0156 14.4844C15.3203 14.7656 15.3203 15.2578 15.0156 15.5391C14.7344 15.8438 14.2422 15.8438 13.9609 15.5391L10 11.5781L6.01562 15.5391C5.73438 15.8438 5.24219 15.8438 4.96094 15.5391C4.65625 15.2578 4.65625 14.7656 4.96094 14.4844L8.92188 10.5L4.96094 6.53906C4.65625 6.25781 4.65625 5.76562 4.96094 5.48438C5.24219 5.17969 5.73438 5.17969 6.01562 5.48438L10 9.44531L13.9609 5.48438Z"
              fill="currentColor"
            />
          </svg>
        </template>
      </TButton>
      <div
        class="draggable flex items-center gap-3 px-3 pb-3 pt-5"
        @dblclick="goHome"
      >
        <div
          v-if="$slots.headerIcon"
          class="box-border grid h-[40px] w-[40px] items-center justify-center rounded-md border border-solid border-gray-500"
        >
          <slot name="headerIcon" />
        </div>
        <h1
          class="block font-inter text-base font-semibold leading-4 text-gray-50"
        >
          {{ header }}
        </h1>
      </div>

      <slot />
    </div>
  </div>

  <div
    v-if="showHomePosition"
    class="height-full-preview fixed left-0 top-[106px] z-[998] w-[304px] overflow-y-auto overflow-x-hidden bg-gray-300 opacity-25"
  ></div>
</template>

<script setup lang="ts">
  import { useTopBarStore } from "@/stores/topBar";
  import { TButton } from "@topol/twig-ui";
  import interact from "interactjs";
  import { ref, onMounted, onUnmounted } from "vue";

  const isDragging = ref(false);
  const showHomePosition = ref(false);
  const position = ref({ x: 0, y: 0 });

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
  });

  const topBarStore = useTopBarStore();

  const emits = defineEmits(["close", "dragging"]);

  function goHome() {
    const element = document.getElementById(props.id);
    if (props.draggable && element) {
      position.value.x = 0;
      position.value.y = 0;
      element.style.transform = "";
      isDragging.value = false;
      showHomePosition.value = false;
      emits("dragging", false);
    }
  }
  onMounted(() => {
    const element = document.getElementById(props.id);
    if (props.draggable && element) {
      interact(`#${props.id} .draggable`).draggable({
        listeners: {
          start() {
            isDragging.value = true;
            emits("dragging", true);
          },
          move(event) {
            position.value.x += event.dx;
            position.value.y += event.dy;
            if (position.value.x < 150 && position.value.y < 150) {
              showHomePosition.value = true;
            } else if (showHomePosition.value) {
              showHomePosition.value = false;
            }
            element.style.transform = `translate(${position.value.x}px, ${position.value.y}px)`;
          },
          end() {
            if (position.value.x < 150 && position.value.y < 150) {
              goHome();
            }
          },
        },
      });
    }
  });
  onUnmounted(() => {
    const element = document.getElementById(props.id);
    if (element) {
      interact(`#${props.id} .draggable`).unset();
      element.style.transform = "";
      emits("dragging", false);
    }
  });
</script>

<style scoped lang="scss">
  .height-full-preview {
    height: calc(100vh - 108px);
  }
</style>
